export enum VerificationStatus {
    INCOMPLETE = "incomplete",
    COMPLETE = "complete",
    PROCESSING = "processing",
    VERIFYING = "verifying",
    LOADING_STATUS = "loading status...", // This is only used on the FE as a placeholder until the BE request is finished
    NO_STATUS = "",
}

export enum DocumentType {
    PASSPORT = "passport",
    DRIVER_LICENSE = "driver_license",
    NATIONAL_ID_CARD = "national_id_card",
    UTILITY_BILL = "utility_bill",
    BANK_STATEMENT = "bank_statement",
    TAX_STATEMENT = "tax_statement",
}

export enum DocumentPurpose {
    PROOF_OF_ADDRESS = "proof_of_address",
    PROOF_OF_IDENTITY = "proof_of_identity",
}

export enum OnboardingVerificationStatus {
    NOT_STARTED = "not_started", // Not started yet
    MORE_INFORMATION_REQUIRED = "more_information_required", // Adyen require more information from the organisation
    PENDING_VERIFICATION = "pending_verification", // All information provided, Adyen are verifying
    VERIFICATION_COMPLETE = "verification_complete", // Verification complete, account holder is onboarded
    ONBOARDING_COMPLETE = "onboarding_complete", // Onboarding complete and account is live and ready to take payments
}

export enum ContractType {
    TERMS_AND_CONDITIONS = "terms_and_conditions",
    COMMERCIAL_TERMS = "commercial_terms",
}
